// extracted by mini-css-extract-plugin
export var tag = "AnchorTag-module--tag--d7679";